import { Timeline, Typography } from "antd"
import dayjs from "dayjs"

import Modal from "#blocks/Modal"

const { Text, Title } = Typography

interface ChangelogModalProps {
  onClose: () => void
  changelogItems?: string[]
  changelogVersion?: string
}

const CHANGELOG_ENTRIES = [
  {
    version: "2.1.0",
    date: "2026-03-05",
    items: [
      "Added notification system with bell icon and popover",
      "Evaluation comments between teacher and reviewer",
    ],
  },
]

const ChangelogModal = ({
  onClose,
  changelogItems,
  changelogVersion,
}: ChangelogModalProps) => {
  if (changelogItems) {
    return (
      <Modal
        title="What's New"
        open
        onClose={onClose}
        width={520}
        footer={null}
        modalName="changelog"
      >
        {changelogVersion && (
          <Text type="secondary" style={{ display: "block", marginBottom: 8 }}>
            Updated {dayjs(changelogVersion).format("MMM D, YYYY h:mm A")}
          </Text>
        )}
        {changelogItems.length > 0 ? (
          <ul style={{ margin: 0, paddingLeft: 20, listStyleType: "disc" }}>
            {changelogItems.map((item, i) => (
              <li key={i} style={{ marginBottom: 6 }}>
                <Text style={{ fontSize: 14 }}>{item}</Text>
              </li>
            ))}
          </ul>
        ) : (
          <Text type="secondary">No changelog details provided.</Text>
        )}
      </Modal>
    )
  }

  return (
    <Modal
      title="What's New"
      open
      onClose={onClose}
      width={520}
      footer={null}
      modalName="changelog"
    >
      <Timeline
        items={CHANGELOG_ENTRIES.map((entry) => ({
          children: (
            <div key={entry.version}>
              <Title level={5} style={{ margin: 0 }}>
                v{entry.version}
              </Title>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {entry.date}
              </Text>
              <ul
                style={{
                  margin: "6px 0 0",
                  paddingLeft: 18,
                  listStyleType: "disc",
                }}
              >
                {entry.items.map((item) => (
                  <li key={item}>
                    <Text style={{ fontSize: 13 }}>{item}</Text>
                  </li>
                ))}
              </ul>
            </div>
          ),
        }))}
      />
    </Modal>
  )
}

export default ChangelogModal
